import React, { useState, useEffect } from 'react';
import apiService from '../utils/api';
import CircularProgress from '@mui/material/CircularProgress';
import Sidebar from './sidebar/Sidebar';
import './ContractTypes.css';
import Loader from './Loader';
import Snackbar from '@mui/material/Snackbar';
import Delete from '@mui/icons-material/Delete'; 
import Breadcrumbs from './Breadcrumbs'; 

const ContractTypes = () => {
  const [contractTypes, setContractTypes] = useState([]);
  const [filteredContractTypes, setFilteredContractTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newContractTypeName, setNewContractTypeName] = useState('');
  const [editingId, setEditingId] = useState(null);
const [editContractTypeName, setEditContractTypeName] = useState('');
const [editContractTypeDescription, setEditContractTypeDescription] = useState('');
const [isEditModalOpen, setIsEditModalOpen] = useState(false);
const [snackbarOpen, setSnackbarOpen] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [isSuccess, setIsSuccess] = useState(false);
const [newContractTypeDescription, setNewContractTypeDescription] = useState('');
const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false); // Add this
const [deleteContractTypeId, setDeleteContractTypeId] = useState(null); // Add this

const fetchContractTypes = async () => {
    try {
      setIsLoading(true);
      const response = await apiService.fetchData('metadata/contract-type');
      const contractTypesWithDescriptions = response.map(type => ({
        ...type,
        description: type.description || 'No description available'
      }));
      setContractTypes(contractTypesWithDescriptions || []);
      setFilteredContractTypes(contractTypesWithDescriptions || []);
    } catch (err) {
      console.error('Error fetching contract types:', err);
      setError('Failed to load contract types. Please try again later.');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchContractTypes(); // Call the function
  }, []);

  useEffect(() => {
    const filtered = contractTypes.filter(type =>
      type.value.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredContractTypes(filtered);
  }, [searchQuery, contractTypes]);

 const handleAddContractType = async () => {
  if (!newContractTypeName.trim()) {
    setSnackbarMessage('Contract type name is required');
    setIsSuccess(false);
    setSnackbarOpen(true);
    return;
  }

  try {
    setIsLoading(true);
    const newContractType = {
      type_name: newContractTypeName,
      description: newContractTypeDescription || 'No Description',
      updated_by: sessionStorage.getItem('user_id')
    };
    const response = await apiService.postData('create-contract-type', newContractType);
    if (response.status === 'success') {
      await fetchContractTypes(); // Refetch the list
      setNewContractTypeName('');
      setNewContractTypeDescription('');
      setIsModalOpen(false);
      setSnackbarMessage('Contract type added successfully');
      setIsSuccess(true);
      setSnackbarOpen(true);
    } else {
      throw new Error(response.message || 'Failed to add contract type');
    }
  } catch (err) {
    console.error('Error adding contract type:', err);
  const errorMessage = err.response?.status === 500 
    ? 'Contract type already exists' 
    : (err.response?.data?.message || err.message || 'Failed to add contract type. Please try again later.');
  setSnackbarMessage(errorMessage);
  setIsSuccess(false);
  setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
  }
};

const handleSaveEdit = async (id) => {
  if (!editContractTypeName.trim()) {
    setSnackbarMessage('Contract type name is required');
    setIsSuccess(false);
    setSnackbarOpen(true);
    return;
  }
  try {
    setIsLoading(true);
    const originalType = contractTypes.find(type => type.id === id);
    const updatedValues = {};
    if (originalType.value !== editContractTypeName) {
      updatedValues.TypeName = editContractTypeName;
    }
    if (originalType.description !== editContractTypeDescription) {
      updatedValues.description = editContractTypeDescription;
    }
    const payload = {
      values: updatedValues,
      updated_by: sessionStorage.getItem('user_id')
    };
    if (Object.keys(updatedValues).length === 0) {
      setSnackbarMessage('No changes detected');
      setIsSuccess(false);
      setSnackbarOpen(true);
      return;
    }
    const response = await apiService.putData(`update-contract-types/${id}`, payload); // Use id directly, no mapping needed
    if (response.status === 'success') {
      await fetchContractTypes(); // Refetch the list
      setSnackbarMessage('Contract type updated successfully');
      setIsSuccess(true);
      setSnackbarOpen(true);
    } else {
      throw new Error(response.message || 'Failed to update contract type');
    }
  } catch (err) {
    console.error('Error updating contract type:', err);
    setSnackbarMessage(err.message || 'Failed to update contract type. Please try again later.');
    setIsSuccess(false);
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
    setIsEditModalOpen(false);
    setEditingId(null);
    setEditContractTypeName('');
    setEditContractTypeDescription('');
  }
};

const handleDeleteContractType = async (id) => {
  try {
    setIsLoading(true);
    const response = await apiService.deleteData(`metadata/contract-type/${id}`);
    if (response.status === 'success') {
      await fetchContractTypes(); // Refetch the list
      setSnackbarMessage('Contract type deleted successfully');
      setIsSuccess(true);
      setSnackbarOpen(true);
    } else {
      throw new Error(response.message || 'Failed to delete contract type');
    }
  } catch (err) {
    console.error('Error deleting contract type:', err);
    setSnackbarMessage(err.message || 'Failed to delete contract type. Please try again later.');
    setIsSuccess(false);
    setSnackbarOpen(true);
  } finally {
    setIsLoading(false);
    setIsDeleteModalOpen(false);
    setDeleteContractTypeId(null);
  }
};

  return (
  <div className="contract-types-page-container">
    <Sidebar />
    <div className="contract-types-page-content">
       <Breadcrumbs/>
      <div className="contract-types-header">
        <h2 style={{ color: '#ff6b35', fontSize: '24px' }}>Contract Types</h2>
        <button
          className="add-contract-type-button"
          onClick={() => setIsModalOpen(true)}
        >
          Add Contract Type
        </button>
      </div>
     {isLoading ? (
  <Loader isLoading={isLoading} message="Loading Contract Types..." color="#ff6b35" />
) : error ? (
  <div className="error">{error}</div>
) : (
  <>
    <div className="search-container">
      <input
        type="text"
        placeholder="Search contract types..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        className="search-input"
      />
      <svg
        className="contract_types-search-icon"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="#666"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <circle cx="11" cy="11" r="8" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
    </div>
    <table className="contract-types-table">
      <thead>
        <tr>
          <th>ID</th>
          <th>Contract Type</th>
          <th>Contract Type Description</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {filteredContractTypes.length > 0 ? (
          filteredContractTypes.map((type, index) => (
            <tr key={type.id}>
              <td>{index + 1}</td>
              <td>{type.value}</td>
              <td>{type.description || 'No description available'}</td>
              <td>
  <svg
    className="edit-icon"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="#ff6b35"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ cursor: 'pointer', marginRight: '10px', display: 'inline-block', verticalAlign: 'middle' }}
    onClick={() => {
      setIsEditModalOpen(true);
      setEditingId(type.id);
      setEditContractTypeName(type.value);
      setEditContractTypeDescription(type.description || '');
    }}
  >
    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
  </svg>
  <Delete
    style={{
      cursor: 'pointer',
      width: '20px',
      height: '20px',
      color: '#ff6b35',
      display: 'inline-block',
      verticalAlign: 'middle',
    }}
    titleAccess="Delete Contract Type"
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
      console.log(`Delete icon clicked for contract type ID: ${type.id}`); // Debug click
      setDeleteContractTypeId(type.id);
      setIsDeleteModalOpen(true);
    }}
  />
</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan="3">No contract types found.</td>
          </tr>
        )}
      </tbody>
    </table>
  </>
)}
     {isModalOpen && (
  <div className="modal-overlay">
    <div className="contract_types-modal-content">
      <div className="contract_types-modal-header" style={{ backgroundColor: '#ff6b35', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '50px', paddingLeft: '10px', borderTopLeftRadius: '6px', borderTopRightRadius: '6px' }}>
        <h3 style={{ margin: 0 }}>Add Contract</h3>
      </div>
      <div className="contract_types-modal-form">
        <label htmlFor="contract-type-name" className="contract_type-label">Contract Type Name</label>
        <input
          id="contract-type-name"
          type="text"
          value={newContractTypeName}
          onChange={(e) => setNewContractTypeName(e.target.value)}
          placeholder="Enter contract type name"
          className="modal-input"
        />
        <label htmlFor="contract-type-description" className="contract_type-label">Description</label>
        <input
          id="contract-type-description"
          type="text"
          value={newContractTypeDescription}
          onChange={(e) => setNewContractTypeDescription(e.target.value)}
          placeholder="Enter description"
          className="modal-input"
        />
      </div>
      <div className="modal-buttons">
        <button
          className="modal-button save-button"
          onClick={handleAddContractType}
        >
          Save
        </button>
        <button
          className="modal-button cancel-button"
          onClick={() => {
            setNewContractTypeName('');
            setNewContractTypeDescription('');
            setIsModalOpen(false);
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}


      {isEditModalOpen && (
        <div className="modal-overlay">
          <div className="contract_types-modal-content">
            <div className="contract_types-modal-header" style={{ backgroundColor: '#ff6b35', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '50px', paddingLeft: '10px', borderTopLeftRadius: '6px', borderTopRightRadius: '6px' }}>
              <h3 style={{ margin: 0 }}>Update Contract</h3>
            </div>
            <div className="contract_types-modal-form">
              <label htmlFor="edit-contract-type-name" className='contract_type-label'>Contract Type Name</label>
              <input
                id="edit-contract-type-name"
                type="text"
                value={editContractTypeName}
                onChange={(e) => setEditContractTypeName(e.target.value)}
                placeholder="Enter contract type name"
                className="modal-input"
              />
              <label htmlFor="edit-contract-type-description" className='contract_type-label'>Description</label>
              <input
                id="edit-contract-type-description"
                type="text"
                value={editContractTypeDescription}
                onChange={(e) => setEditContractTypeDescription(e.target.value)}
                placeholder="Enter description"
                className="modal-input"
              />
            </div>
            <div className="modal-buttons">
              <button
                className="modal-button save-button"
                onClick={() => handleSaveEdit(editingId)}
              >
                Save
              </button>
              <button
                className="modal-button cancel-button"
                onClick={() => {
                  setIsEditModalOpen(false);
                  setEditingId(null);
                  setEditContractTypeName('');
                  setEditContractTypeDescription('');
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {isDeleteModalOpen && (
  <div className="modal-overlay">
    <div className="contract_types-modal-content">
      <div className="contract_types-modal-header" style={{ backgroundColor: '#ff6b35', color: 'white', display: 'flex', justifyContent: 'space-between', alignItems: 'center', height: '50px', paddingLeft: '10px', borderTopLeftRadius: '6px', borderTopRightRadius: '6px' }}>
        <h3 style={{ margin: 0 }}>Confirm Delete</h3>
      </div>
      <div className="contract_types-modal-form">
        <p>Do you want to delete this contract type?</p>
      </div>
      <div className="modal-buttons">
        <button
          className="modal-button save-button"
          onClick={() => handleDeleteContractType(deleteContractTypeId)}
        >
          Delete
        </button>
        <button
          className="modal-button cancel-button"
          onClick={() => {
            setIsDeleteModalOpen(false);
            setDeleteContractTypeId(null);
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
)}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        sx={{
          '& .MuiSnackbarContent-root': {
            backgroundColor: isSuccess ? '#4caf50' : '#f44336',
          },
          zIndex: 1400,
        }}
      />
    </div>
  </div>
);
};

export default ContractTypes;